import type { IHttpRequestRunner } from 'shared/domain/httpRequest/httpRequestRunner';
import {
  ChecklistAnswerHttpCreateRequestModel,
  ChecklistAnswerHttpDeleteRequestModel,
  ChecklistAnswerHttpEditRequestModel,
  ChecklistAnswerHttpRequestModel,
} from './types';
import { Fetcher } from '../fetcher';
import { ChecklistItemAnswerInDto } from 'shared/dtos/in/template';

export class ChecklistAnswerRequestRunner implements IHttpRequestRunner {
  constructor(
    private fetcher: typeof Fetcher,
    private removeChecklistAnswerFromTemplate: (
      templateId: string,
      checklistItemId: string,
      answerId: string
    ) => Promise<unknown>
  ) {}

  async execute(
    request: ChecklistAnswerHttpRequestModel
  ): Promise<ChecklistItemAnswerInDto | void> {
    switch (request.method) {
      case 'POST': {
        return this.createAnswer(request);
      }
      case 'PUT': {
        return this.updateAnswer(request);
      }
      case 'DELETE': {
        return this.deleteAnswer(request);
      }
    }
  }

  private async createAnswer(
    request: ChecklistAnswerHttpCreateRequestModel
  ): Promise<ChecklistItemAnswerInDto> {
    const response = await this.fetcher.POST(
      request.url,
      request.data.checklistAnswerOutDto
    );
    return response as ChecklistItemAnswerInDto;
  }

  private async updateAnswer(
    request: ChecklistAnswerHttpEditRequestModel
  ): Promise<ChecklistItemAnswerInDto> {
    const response = await this.fetcher.PUT(
      request.url,
      request.data.checklistAnswerOutDto
    );
    return response as ChecklistItemAnswerInDto;
  }

  private async deleteAnswer(
    request: ChecklistAnswerHttpDeleteRequestModel
  ): Promise<void> {
    await this.fetcher.DELETE(request.url);
    await this.removeChecklistAnswerFromTemplate(
      request.data.inspectionTemplateId,
      request.data.checklistItemId,
      request.data.answerId
    );
  }
}
